export const EndScreenType = {
  APP_PREVIEW: 'app_preview',
  DEFAULT: 'default',
  HTML: 'html',
  IFRAME: 'iframe',
  IMAGE: 'image'
} as const;

export type EndScreenTypeValue = typeof EndScreenType[keyof typeof EndScreenType];

export const EndScreenOrigin = {
  MANAGED: 'managed',
  VAST: 'vast'
} as const;

export type EndScreenOriginValue = typeof EndScreenOrigin[keyof typeof EndScreenOrigin];

export const AdUnitType = {
  INTERSTITIAL: 'interstitial',
  REWARD: 'optin_video',
  MPU: 'medium_rectangle',
  THUMBNAIL: 'overlay_thumbnail',
  IN_ARTICLE: 'in_article',
  STANDARD_BANNERS: 'standard_banners'
} as const;

export type AdUnitTypeValue = typeof AdUnitType[keyof typeof AdUnitType];

export const EndScreenSkipType = {
  AUTO: 'auto',
  MANUAL: 'manual'
} as const;

export type EndScreenSkipTypeValue = typeof EndScreenSkipType[keyof typeof EndScreenSkipType];
